import { dynamicVariableRegex } from '@/modules/admin/workflows/components/VariableSelector/utils'

void dynamicVariableRegex

export const capitalCase = (string?: string) => {
    if (!string) return ''

    return string[0].toUpperCase() + string.substring(1)
}

export const addSpacesToCamelCase = (str: string, capital = true) => {
    if (!str) return ''
    const spaced_string = str
        .replace(/([A-Z])/g, ' $1')
        .replaceAll('_', ' ')
        .replaceAll('-', ' ')
        .trim()

    if (!capital) return spaced_string

    return capitalCase(spaced_string)
}

export const capitalCaseWithSpaces = (string?: string) => {
    if (!string) return ''

    return string
        .replace(/([A-Z])/g, ' $1')
        .replaceAll('_', ' ')
        .replaceAll('-', ' ')
        .trim()
}

export const isPrimitiveValue = (value: any) => {
    return typeof value !== 'object' && value !== null && !Array.isArray(value)
}

export const isDynamicVariable = (value: string) => {
    const regex = new RegExp(dynamicVariableRegex)
    return regex.test(value)
}
